/* eslint no-magic-numbers: "off"*/
/* global Foundation */

import ScrollMagic from 'scrollmagic';

const LARGE = 1279;
const controller = new ScrollMagic.Controller();
let scene = [];
const enableFancyScroll = ( num, el ) => {

  let pin = el;
  let slides = parseInt( el.parent().attr( 'data-count' ) );
  let timeBlock = 1 / slides;
  let duration = slides * 600;

  scene[num] = new ScrollMagic.Scene({
    triggerElement: pin[0],
    triggerHook:    '0',
    duration:       duration // Pin the element for 400px of scrolling
  }).setPin( pin[0])
    .on( 'progress', function( event ) {
      for ( let index = 0; index < slides; index++ ) {
        if ( event.progress > index * timeBlock && event.progress <= ( index + 1 ) * timeBlock ) {
          el.slick( "slickGoTo", index );
        }
      }
    })
    .addTo( controller ) ;

  el.find( '.slick-dots li' ).on( 'click', ( event ) => {
    event.stopPropagation(); // Use this
    let sliderIndex = parseInt( jQuery( event.currentTarget ).find( 'button' ).text() ) - 1;
    controller.scrollTo( el.parent().offset().top + duration * timeBlock * sliderIndex );
  });

};

const initTextImageSlider = () => {

  jQuery( '.module--text-image-slider .text-image-slider' ).each( ( index, textImage ) => {

    if ( '1' === jQuery( textImage ).parent().attr( 'data-count' ) ) {
      return;
    }

    let autoPlay = true;
    let swipe = true;

    if ( 'on' === jQuery( textImage ).parent().attr( 'data-fancy-scroll' ) &&
      Foundation.MediaQuery.is( 'large' ) ) {
      autoPlay = false;
      swipe = false;

      jQuery( textImage ).on( 'init', ()=> {
        enableFancyScroll( index, jQuery( textImage ) );
      });

    }

    jQuery( textImage ).slick({
      arrows:         false,
      dots:           true,
      fade:           true,
      autoplay:       autoPlay,
      autoplaySpeed:  20000,
      pauseOnFocus:   false,
      swipe:          swipe,
      adaptiveHeight: true,
      responsive:     [ {
        breakpoint:     '1279',
        adaptiveHeight: false
      } ]
    });

  });

};

const updateModuleHeight = () => {
  let $moduleWrapper = $( '.module--text-image-slider' );

  $moduleWrapper.each( function() {
    let $video = $( this ).find( 'video' );
    if ( $video && $video.length ) {
      $( this ).css( 'height', $video.height() + 'px' );
    }
  });
};

const backgroundImageSlideIn = ( el ) => {
  let $el = $( el );
  new ScrollMagic.Scene({
    triggerElement: $el[0],
    offset:         200,
    triggerHook:    0.9,
    reverse:        false,
  }).addTo( controller )
    .setClassToggle( $el[0], 'animated' );
};

const fadeInContent = ( el ) => {
  let $el = $( el );
  new ScrollMagic.Scene({
    triggerElement: $el[0],
    offset:         200,
    triggerHook:    0.9,
    reverse:        false,
  }).addTo( controller ).on( 'start', function() {
    setTimeout( () => {
      $el.find( '.text-image-center-image ' ).removeClass( 'hide-content' );
      $el.find( '.text-image-content .top-content' ).removeClass( 'hide-content' );
      setTimeout( () => {
        $el.find( '.text-image-content .bottom-content' ).removeClass( 'hide-content' );
      }, 300 );
    }, 450 );
  });
};

jQuery( () => {
  initTextImageSlider();
  $( window ).resize( function() {
    updateModuleHeight();
  }).resize();
});

$( window ).on( 'load', function() {
  $( '.module--text-image-slider .text-image-wrapper:not(.slick-slider) ' +
    '.bg-img.anim-bg' ).each( function( index, el ) {
    if ( window.innerWidth >= LARGE ) {
      backgroundImageSlideIn( el );
    }
  });

  $( '.module--text-image-slider .text-image-container' ).each( function( index, el ) {
    if ( window.innerWidth >= LARGE ) {
      fadeInContent( el );
    }
  });

});
